import React, { useState } from "react";
import TopbarNav from "../../components/TopbarNav";
import SidebarNav from "../../components/MasterSideBar"; // Consistent naming
import Disciplinary from "../../components/Disciplinary";
import { useNavigate } from "react-router-dom";

function PDDisciplinaryInterface() {
  const navigate = useNavigate();

  // Sidebar state for mobile toggle
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  return (
    <div className="flex min-h-screen bg-gray-50 font-sans">
      {/* 1. Master Sidebar - Standard structure */}
      <SidebarNav 
        visible={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
        onLogout={handleLogout}
      />

      {/* 2. Main Content Area - Responsive margin handling */}
      <div className="flex-1 flex flex-col md:ml-64 transition-all duration-300">
        
        {/* 3. Topbar - Fixed at top of the flex-1 container */}
        <TopbarNav onSidebarToggle={() => setSidebarOpen(true)} />

        {/* 4. Page Content */}
        <main className="p-4 md:p-8 mt-16 lg:mt-20">
          <header className="mb-8">
            <h1 className="text-2xl md:text-3xl font-black text-gray-800 uppercase tracking-tight">
              Disciplinary Actions
            </h1>
            <p className="text-gray-500 text-sm mt-1">
              Review, document, and manage employee disciplinary records and compliance.
            </p>
          </header>

          {/* Wrapper for the internal component to ensure it follows the page's theme */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-2">
             <Disciplinary />
          </div>
        </main>
      </div>
    </div>
  );
}

export default PDDisciplinaryInterface;